module.exports = __webpack_public_path__ + "static/media/logo.04ea6ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 180
// module chunks = 0